import '../../App.css';

import error from '../../img/svg/question-circle.svg';
import bg6 from '../../img/bg3.jpg';

function Step2({
  setPage,
  page,
  nombre,
  setNombre,
  nombreAlert,
  setNombreAlert,
  apellido,
  setApellido,
  apellidoAlert,
  setApellidoAlert,
  telefono,
  setTelefono,
  telefonoAlert,
  setTelefonoAlert,
  region,
  setRegion,
  regionAlert,
  setRegionAlert,
  financiacion,
  setFinanciacion,
  financiacionAlert,
  setFinanciacionAlert,
  setNivelEstudiosAlert,
  nivel_estudiosAlert,
  nivel_estudios,
  setNivelEstudios,
  setSituacionLaboral,
  situacion_laboral,
  situacion_laboralAlert,
  setSituacionLaboralAlert,
  validation,
  termycond,
  setTyc,
  regiones,
  situaciones_laboral,
  financiamientos,
  niveles_estudio,
}) {
  const isAllowedToPass = () => {
    if (validationPage2()) {
      setPage((currentPage) => currentPage + 1);
    }
  };

  const validationPage2 = () => {
    let isOk = true;

    if (nombre === '') {
      isOk = false;
      setNombreAlert('error_label');
    }

    if (apellido === '') {
      isOk = false;
      setApellidoAlert('error_label');
    }

    if (telefono === '' || telefono.length !== 9) {
      isOk = false;
      setTelefonoAlert('error_label');
    }

    if (financiacion === '') {
      isOk = false;
      setFinanciacionAlert('error_label');
    }

    if (situacion_laboral === '') {
      isOk = false;
      setSituacionLaboralAlert('error_label');
    }

    if (nivel_estudios === '') {
      isOk = false;
      setNivelEstudiosAlert('error_label');
    }

    if (termycond !== true) {
      isOk = false;
    }

    return isOk;
  };

  const getOptionsEstudios = () => {
    return niveles_estudio.map((reg, i) => {
      return (
        <>
          <option key={i} value={reg.id_nivel_estudios}>
            {reg.nivel_estudios}
          </option>
        </>
      );
    });
  };

  const getOptionsSitLaboral = () => {
    return situaciones_laboral.map((reg, i) => {
      return (
        <>
          <option key={i} value={reg.id_situacion_laboral}>
            {reg.situacion_laboral}
          </option>
        </>
      );
    });
  };

  const getOptionsFinanciamiento = () => {
    return financiamientos.map((reg, i) => {
      return (
        <>
          <option key={i} value={reg.id_financiamiento_carrera}>
            {reg.financiamiento_carrera}
          </option>
        </>
      );
    });
  };

  return (
    <section class="step style--2">
      <div class="section--bg img--bg ">
        <img className="back2" alt="" />
      </div>
      <div class="in">
        <header class="marquee">
          <div class="in">
            <div class="maxwidth">
              <div class="logo gone"></div>
              <div class="ttl">
                <h2>Datos Personales y Profesionales</h2>
              </div>
              <div class="air gone"></div>
            </div>
          </div>
        </header>
        <main>
          <div class="maxwidth2">
            <div class="ttl big text--center titular destacado bluecolor">
              Cuéntanos <strong className="bold_letter">un poco más de ti</strong>
            </div>
          </div>
          <div class="maxwidth2">
            <div class="cols cols2">
              <div class="col col1">
                <div class="list">
                  <div class="field input field_pad">
                    <label>
                      <span class="name">
                        <span>Nombres</span>
                      </span>
                      <input
                        id="nombre"
                        value={nombre}
                        class={nombreAlert}
                        type="text"
                        placeholder="Ej: Juan Andrés"
                        name="nombre"
                        onChange={(e) => {
                          if (e.target.value.match('^[a-zA-Z ]*$') != null) {
                            setNombre(e.target.value);
                            setNombreAlert('required empty');
                          }
                        }}
                      />
                    </label>
                  </div>
                  <div class="field input field_pad">
                    <label>
                      <span class="name">
                        <span>Apellidos</span>
                      </span>
                      <input
                        value={apellido}
                        class={apellidoAlert}
                        id="apellido"
                        type="text"
                        placeholder="Ej: López Pérez"
                        name="apellido"
                        onChange={(e) => {
                          setApellido(e.target.value.replace(/[^a-zA-Z\-]+/gi, ''));
                          setApellidoAlert('required empty');
                        }}
                      />
                    </label>
                  </div>
                  <div class="field input field_pad">
                    <label>
                      <span class="name">
                        <span>Teléfono </span>
                      </span>
                      <div className='tel_wrap'>
                        <div className='tel_code'>
                          <span>+56</span>
                        </div>
                        <input
                          id="telefono"
                          class={telefonoAlert}
                          type="text"
                          placeholder="Ej: 123456789"
                          name="telefono"
                          value={telefono}
                          onChange={(e) => {
                            setTelefono(e.target.value.replace(/[^0-9\-]+/gi, ''));
                            setTelefonoAlert('required empty');
                          }}
                        />
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col col1">
                <div class="list">
                  <div class="field select select_pad">
                    <label>
                      <span class="name">
                        <span>Nivel de estudios</span>
                      </span>
                      <div data-help="Crédito con Aval del Estado, corresponde a un préstamo bancario que financia tus estudios de manera parcial o total, el cual debes comenzar a pagar en cuotas luego de terminar la Universidad.">
                        <select
                          id="estudios"
                          class={nivel_estudiosAlert}
                          value={nivel_estudios}
                          onChange={(e) => {
                            setNivelEstudios(e.target.value);
                            setNivelEstudiosAlert('required empty');
                          }}
                        >
                          <option value="">Selecciona</option>
                          {getOptionsEstudios()}
                        </select>
                      </div>
                    </label>
                  </div>
                  <div class="field select select_pad">
                    <label>
                      <span class="name">
                        <span>Situación laboral</span>
                      </span>
                      <div data-help="Crédito con Aval del Estado, corresponde a un préstamo bancario que financia tus estudios de manera parcial o total, el cual debes comenzar a pagar en cuotas luego de terminar la Universidad.">
                        <select
                          id="situacionLaboral"
                          class={situacion_laboralAlert}
                          value={situacion_laboral}
                          onChange={(e) => {
                            setSituacionLaboral(e.target.value);
                            setSituacionLaboralAlert('required empty');
                          }}
                        >
                          <option value="">Selecciona</option>
                          {getOptionsSitLaboral()}
                        </select>
                      </div>
                    </label>
                  </div>
                  <div class="field select select_pad">
                    <label>
                      <span class="name">
                        <span>¿Cómo financiarás tu carrera Advance?</span>
                      </span>
                      <div data-help="Crédito con Aval del Estado, corresponde a un préstamo bancario que financia tus estudios de manera parcial o total, el cual debes comenzar a pagar en cuotas luego de terminar la Universidad.">
                        <select
                          id="financiacion"
                          class={financiacionAlert}
                          value={financiacion}
                          onChange={(e) => {
                            setFinanciacion(e.target.value);
                            setFinanciacionAlert('required empty');
                          }}
                        >
                          <option value="">Selecciona</option>
                          {getOptionsFinanciamiento()}
                        </select>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="maxwidth2 text--center">
            <div class="field checkbox">
              <label class="woah--holder">
                <input
                  id="termYCond"
                  class="required empty no--woah"
                  type="checkbox"
                  checked={termycond}
                  onChange={() => setTyc((currentValue) => !currentValue)}
                />
                <span>
                  Acepto los <a href="https://www.unab.cl/politicas-de-privacidad/">Términos y Condiciones</a>.
                </span>
              </label>
            </div>
          </div>
          <div class="button submit">
            <button
              id="button_submit"
              name="button_submit"
              onClick={() => {
                isAllowedToPass();
              }}
            >
              Continuar &darr;
            </button>
          </div>
        </main>
      </div>
    </section>
  );
}

export default Step2;
